import React from 'react';

import * as styles from './SectionTitle.styles';

interface SectionTitleProps {
  copy: string;
}

export const SectionTitle = ({ copy }: SectionTitleProps) => {
  return <h3 css={styles.sectionTitle}>{copy}</h3>;
};
